<template>
      <section >
            <div class="w-full mhs relative bg-gray-100">
                  <div
                        v-if="activeImage && colours"
                        class="
                        w-full
                        h-full
                        absolute
                        top-0
                        left-0
                        flex
                        justify-center
                        items-center
                        text-center
                        "
                        @click="nextView"
                  >
                        <img
                        v-if="activeImage && activeImage.type == 'image'"
                        data-size="auto"
                        :alt="item.title"
                        :src="activeImage.thumb"
                        :srcset="activeImage.srcset"
                        class="lazyload w-full h-full object-cover"
                        />
                        <video
                        v-if="activeImage && activeImage.type == 'video'"
                        :src="activeImage.url"
                        class="w-full h-full object-cover"
                        playsinline
                        muted
                        autoplay
                        loop
                        ></video>
                  </div>
                  <div
                        class="
                        toolbar
                        w-full
                        absolute
                        bottom-0
                        left-0
                        p-4
                        flex
                        items-end
                        flex-wrap
                        "
                  >
                        <div class="mb-4 lg:mb-0 w-full lg:w-auto flex flex-col items-start">
                        <div class="btn-container">
                              <div class="btn active" @click="prevView">&#60;</div>
                              <div class="btn active" @click="nextView">&#62;</div>
                        </div>
                        </div>
                        <div class="flex-1"></div>
                        <div class="mr-4" v-if="activeItem && activeItem.preorder">
                              <div class="label">Pre-order</div>
                              <div class="btn-container">
                                    <div class="btn active msg">{{ activeItem.launch }}</div>
                              </div>
                              </div>
                        
                        <div class="mr-4">
                              <div class="label">Size</div>
                              <div class="btn-container">
                                    <div
                                          v-for="size in sizes"
                                          :key="size.size"
                                          class="btn black"
                                          :class="{
                                          active: activeSize == size.size,
                                          'soldout inactive': parseInt(size.stock) == 0,
                                          }"
                                          @click="changeSize(size.size)"
                                    >
                                          {{ size.size }}
                                    </div>
                              </div>
                        </div>
                        <div class="mr-4 flex flex-col items-start">
                              <div class="label">Colours</div>
                              <div class="btn-container">
                                    <div
                                          v-for="item in colours"
                                          :key="item.colorname"
                                          class="btn"
                                          :class="{
                                            active: activeColour == item.colorname
                                          }"
                                          @click="
                                            activeColour = item.colorname;
                                            activeCode = item.color;
                                          "
                                          :style="{ 'background-color': item.color }"
                                    >
                                          <span class="text-white" v-if="item.showcolorname">{{ item.colorname }}</span>
                                    </div>
                              </div>
                        </div>
                        <div class="mr-4">
                              <div class="label">Price</div>
                              <div class="btn-container">
                                    <div class="btn active msg">€ {{ item.price }}</div>
                              </div>
                        </div>
                        <div class="w-full lg:w-auto flex items-end mt-4">
                              <div class="label"></div>
                              <div class="btn-container">
                                    <div role="button" v-if="!activeItem || activeItem.stock == 0" class="btn inactive">Soldout</div>
                                    <div v-else-if="total < 5" @click="addToCart" class="btn action">
                                        Add to cart
                                    </div>
                                    <div v-else class="btn inactive">Cart full</div>
                              </div>
                        </div>
                  </div>
            </div>
            <!-- <div class="p-4">
                  <h1>{{ item.title }}</h1>
                  <div v-html="item.description"></div>
            </div> -->
      </section>
</template>

<script>
import "lazysizes";
export default {
  props: {
    item: Object,
  },
  data() {
    const stock = (this.item && this.item.stock) || [];
    const firstAvailable =
      stock.find((s) => parseInt(s.stock) > 0) || stock[0];
    const views = (this.item && this.item.views) || [];
    return {
      activeView: views[0] ? views[0].name : "1",
      activeSize: firstAvailable ? firstAvailable.size : "",
      activeColour: firstAvailable ? firstAvailable.colorname : "",
      activeCode: firstAvailable ? firstAvailable.color : null,
      soldout: false,
    };
  },
  computed: {
    total() {
      return this.$store.getters["totalItems"];
    },
    sizes() {
        const items = this.item.stock; 
        const activeColour = this.activeColour;
        const sizes = items.filter((item) => item.colorname == activeColour);
        return sizes;
    },
    colours() {
        const items = this.item.stock.map((item) => {
            return {
                colorname: item.colorname,
                color: item.color,
                stock: item.stock,
            };
        });
        const colours = items.filter((value, index, self) => self.findIndex((t) => t.colorname === value.colorname) === index);
        return colours;
    },
    activeItem() {
      return this.item.stock.filter(
        (item) =>
          item.size == this.activeSize && item.colorname == this.activeColour
      )[0];
    },
    activeImage() {
      if (this.colours && this.item) {
        const images = this.item.images;
        const img = images.filter((img) => {
          if (img.colour) {
            return (
              this.activeView == img.view && this.activeColour == img.colour
            );
          } else {
            return this.activeView == img.view;
          }
        });
        return img[0];
      } else {
        return null;
      }
    },
  },
  _methods: {
      prevView() {
          if (this.activeView == 1) {
              this.activeView = this.item.views[this.item.views.length - 1].name;
          } else {
              this.activeView--;
          }
      },
      nextView() {
          if (this.activeView == this.item.views.length) {
              this.activeView = this.item.views[0].name;
          } else {
              this.activeView++;
          }
      },
      changeSize(size) {
          this.activeSize = size;
        //   let item = this.colours.filter(
            //   (item) => item.stock < 1 && item.colorname == this.activeColour
        //   );
        //   if (item.length > 0) {
            //   let newitem = this.colours.filter((item) => item.stock > 0);
            //   this.activeColour = newitem[0].colorname;
        //   }
      },
      addToCart() {
          this.$store.commit("addToCart", {
              title: this.item.title,
              id: this.activeColour + this.activeSize,
              size: this.activeSize,
              colour: this.activeColour,
              code: this.activeCode,
              img: this.activeImage.url,
              price: this.item.price,
              preorder: this.activeItem.preorder,
              launch: this.activeItem.launch,
              message: this.activeItem.message,
              quantity: 1,
          });
          this.$router.push({ name: "cart" });
      },
  },
  get methods() {
      return this._methods;
  },
  set methods(value) {
      this._methods = value;
  },
};
</script>
